import SuccessfullyCancelledModal from './SuccessfullyCancelledModal';
export default SuccessfullyCancelledModal;